import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/core/services/data.service';
declare var window: any;

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit, OnDestroy {
  path: string;
  reportData: any;
  subscriptions: Subscription[] = [];
  constructor( private dataService: DataService,public router: Router,) {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.dataService.currentData.subscribe(data => {
        if(data){
          this.reportData = data.data;
          this.path = data.path;
          this.createReport();
        }
        else{
        this.router.navigate(['/main/sale-orders']);
        }
      })
    );
  }

  createReport() {
    // window.Stimulsoft.Base.StiLicense.Key = '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHlyBxErOHyaSR9igWOmIpe54D459EnV27B85mUVtGMJoAJ5J4RRiq3EfolQPYY1F49n0mb+F3MG+0ljOxwN4HATAf6fYoKQ1/iUgY6vaEeC5sHh8gfGTprH6x1fC/NVcPUJ/i6KWSxBY4nIv4lRlX3HOUO3USw0i4dW/9jx9b0QNwcDq4rFeRQw7kTTgkRKmY919lyMvTzfZR8CDGeZLM/HMpmj4ECf64h80SPx1SsMENkOUYkdxWM6RgqOgEc44sMRrb+fGswOItPe+m4VPrei7ioUJDxdHtMlA6PPimgjVQdmfF71YEZn01y2M3by3Y3NoELAswiU5MMV2QeaiPTV/eUpEUyICJPT8qLm8NvbBJytSFUM6wCi7NM6rSsjFaVWmpSmfZNJYIGS1DjNadeN62H7tGzPd8WwmKojrERdKtV1df3Uh3FK72EIyeIvc6E5XQCemL1C9dNvvcXaxSDRwPP2ax7In67L6Wb6pOKS+4KqxU+ga/dUN0ayxngW/BIl/KCSaMXCot2h1L/1q0x7';
    window.Stimulsoft.Base.StiLicense.Key = '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHlvy7swiy4OyZGvzRjs6n99N88o4JbVAKkjbJV6KYeYCE33xQCK1UN/i3lYLEPtEhq2w53KS0TnQbUET/m0s2+M378aQoRmYYabN3cWHORSa4bQm1aY4Y7t+TyXH26PKNVleAF81N0NN1O8z4OMQ8vb0OS9theAs2hzIQlDaiYr3y9oLw96qu4ze8oqC06FiwpjV2M8nq/xihBNtfQPcVdG7hVXi9rJJG998TXUX4wb0HXGuHyVUDoVrnrIyC+gSYGkocu6UORD4+AQuGEVgotJoPFY9wwOTkUyufHfy0xtTnYCYzE9QMLrTx31VJVMdPz6HnMPOxbeIqWBZd00FFC0eXFwxiKdHxfTCO0lqsNGlDrcErfvZwLe/Bc0lIKkyPmr1o9gGGJClgHtgsQLT/2mNxrXR34AfkORSmd/l6VSMel6hp0VYUCR2lr5480lpy6h00orzE+aGHALS/pOLBtRAMcRa+V5T65wTmDNl5wnx1IX3870GdJMNSMCO7TIZ4QvWA/R0JY6JCnQRcnNs9C3';
    console.log( window.Stimulsoft.Base.StiLicense.Key)
    console.log(window.Stimulsoft)
    //window.Stimulsoft.Base.Localization.StiLocalization.setLocalizationFile("assets/localization/en.xml", true);
    var rOptions = new window.Stimulsoft.Viewer.StiViewerOptions();
    rOptions.appearance.scrollbarsMode = true;
    rOptions.toolbar.showDesignButton = false;
    rOptions.height = "780px";
    rOptions.appearance.htmlRenderMode = window.Stimulsoft.Report.Export.StiHtmlExportMode.Table;
    /* rOptions.toolbar.printDestination = window.Stimulsoft.Viewer.StiPrintDestination.Direct;  */
    rOptions.appearance.showTooltips = true;
    if (this.reportData.challan) {
      rOptions.toolbar.showPrintButton = this.reportData.challan.paidDate ? false : true;
      rOptions.toolbar.showSaveButton = this.reportData.challan.paidDate ? false : true;
    } else {
      rOptions.toolbar.showPrintButton = true;
      rOptions.toolbar.showSaveButton = true;
    }
    rOptions.toolbar.showAboutButton = false;
    rOptions.exports.showExportToPdf = true;
    rOptions.exports.showExportToCsv = false;
    rOptions.exports.showExportToDocument = false;
    rOptions.exports.showExportToExcel2007 = false;
    rOptions.exports.showExportToHtml5 = false;
    rOptions.exports.showExportToWord2007 = false;
    rOptions.exports.showExportToHtml = false;
    var viewer = new window.Stimulsoft.Viewer.StiViewer(rOptions, 'StiViewer', false);
    var report = new window.Stimulsoft.Report.StiReport();
    report.loadFile(this.path);
    report.dictionary.databases.clear();
    report.dictionary.dataSources.clear();
    report.dictionary.relations.clear();
console.log(report)
console.log(viewer)
    var dataSet = new window.Stimulsoft.System.Data.DataSet("root");
    dataSet.readJson(JSON.stringify(this.reportData));
    report.regData("root", "root", dataSet);
    report.dictionary.synchronize();
    viewer.report = report;
    viewer.renderHtml('viewerContent');
  }

  // closeModal() {
  //   this.activeModal.close('Modal Closed');
  // }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
